import { forwardRef, SVGProps } from 'react';
import { cva, VariantProps } from 'cva';
import { twMerge } from 'tailwind-merge';

import { IconType } from 'types/icon';

const icon = cva({
  variants: {
    size: {
      xs: 'h-3 w-3',
      sm: 'h-4 w-4',
      md: 'h-5 w-5',
      lg: 'h-6 w-6',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

type IconProps = SVGProps<SVGSVGElement> &
  VariantProps<typeof icon> & {
    name: IconType;
  };

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ name, size, className, ...props }, ref) => {
    return (
      <svg {...props} className={twMerge(icon({ size }), className)} ref={ref}>
        <use xlinkHref={`/__spritemap#sprite-${name}`} />
      </svg>
    );
  }
);

Icon.displayName = 'Icon';
